export var BannerType;
(function (BannerType) {
    BannerType["ImageBanner"] = "image-banner";
    BannerType["TextBanner"] = "text-banner";
})(BannerType || (BannerType = {}));
